import permissions from './permission-list'

export default [
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/chat/index.vue'),
    meta: {
      resource: permissions.chat,
      action: 'manage',
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
  {
    path: '/chat-feedback',
    name: 'chat-feedback',
    component: () => import('@/views/chat/Feedback.vue'),
    meta: {
      resource: permissions.chat,
      action: 'manage',
    },
  },
]
